/* -------------------------------------------------------------------------- *
 * App *
 * -------------------------------------------------------------------------- */

import Responder from './_modules/Responder';
import Nav from './_modules/Nav';
import Toggle from './_modules/Toggle';
import Map from './_modules/Map';
import Validate from './_modules/Validate';
import InternationalFields from './_modules/InternationalFields';
import VideoModal from './_modules/VideoModal';
import Lightbox from './_modules/lightbox';
import AnchorLink from './_modules/AnchorLink';

/* -------------- *
 * Initialization *
 * -------------- */

Responder.init();

if (document.getElementById('js-nav')) {
    Nav.init();
}

if (document.querySelector('.js-toggle') !== null) {
    Toggle.init();
}

if (document.getElementById('js-map')) {
    Map.init();
}

if (document.querySelector('.js-validate') !== null) {
    Validate.init();
}

if (document.querySelector('.js-countrySelect') !== null) {
    InternationalFields.init();
}

if (document.querySelector('.js-videoModalButton') !== null) {
    VideoModal.init();
}

if (document.querySelector('.js-anchorLink') !== null) {
    AnchorLink.init();
}

if (document.querySelector(Lightbox.selector) !== null) {
    Lightbox.init();
}
